<template>
  <div>
    <div v-if="!loading" style="width: 100%; text-align: center;"><button class="btn-print" v-on:click="printChallan()">Print Challan</button></div>
    <table v-if="!loading" style="width: 100%;">

      <tr>
        <td v-for="(item, ind) in copies" v-bind:style="getStyle(ind)">
          <table style="width: 100%">
            <tr>
              <td style="width: 20%; text-align: left; padding-top: 2%">
                <img style="width: 80%" v-bind:src="head.Logo" />
              </td>
              <td style="text-align: center; vertical-align: middle">
                <h4 style="margin-bottom: 0px">{{head.Name}}</h4>
                <small>{{head.Address}}</small><br />
                <small>{{head.ContactNo}}</small><br />
              </td>
              <td style="width: 20%; text-align: right; padding-top: 2%">
                <img style="width: 100%" v-bind:src="head.QR" />
              </td>
            </tr>

          </table>
          <table v-for="bank in banks" style="width: 100%; font-size: 10px;" border="1">
            <tbody>
              <tr>
                <th style="width: 25%">Bank Title</th>
                <td style="width: 75%">{{bank.BankName}}</td>
              </tr>
              <tr>
                <th>Account Title</th>
                <td>{{bank.AccountTitle}}</td>
              </tr>
              <tr>
                <th>Account No.</th>
                <td>{{bank.AccountNo}}</td>
              </tr>
            </tbody>
          </table>
          <table style="width: 100%;" border="1">
            <thead>
              <tr>
                <th colspan="4" style="text-align: center">{{item}}</th>
              </tr>
            </thead>
          </table>
          <table style="width: 100%; font-size: 10px;" border="1">
            <tbody>
              <tr>
                <th style="width: 20%">Challan No</th>
                <td style="width: 30%; font-size: 12px; font-weight: bold">{{st.ChallanNo}}</td>
                <th style="width: 20%">Admission No.</th>
                <td style="width: 30%; font-size: 12px; font-weight: bold">{{st.AdmissionNo}}</td>
              </tr>
              <tr>
                <th>Due Date</th>
                <td style="width: 30%; font-size: 12px; font-weight: bold">{{st.DueDate}}</td>
                <th>Issue Date</th>
                <td style="width: 30%; font-size: 12px; font-weight: bold">{{st.DateGeneration}}</td>
              </tr>
              <tr>
                <th>Month</th>
                <td>{{st.Month}}</td>
                <th>Name</th>
                <td>{{st.Name}}</td>
              </tr>
              <tr>
                <th>Father Name</th>
                <td>{{st.FatherName}}</td>
                <th>Class</th>
                <td>{{st.Class}}</td>
              </tr>
              <tr>
                <th>Section</th>
                <td>{{st.Section}}</td>
                <th>Session</th>
                <td>{{st.Session}}</td>
              </tr>
              <tr>
                <th>Remarks</th>
                <td colspan="3">{{st.Remarks}}</td>
              </tr>
            </tbody>
          </table>
          <table style="width: 100%; font-size: 10px;" border="1">
            <thead>
              <tr>
                <th style="width: 80%">Fee Particulars</th>
                <th style="width: 20%; text-align: right">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in fee">
                <th v-if="item.FeeHeadID == -3" style="width: 80% ; font-size: 12px">{{item.FeeHeadName}}</th>
                <td v-else style="width: 80%">{{item.FeeHeadName}}</td>

                <th v-if="item.FeeHeadID == -3" style="width: 20%; font-size: 12px; text-align: right">{{item.TotalAmount.toLocaleString()}}</th>
                <td v-else style="width: 20%; text-align: right"><span v-if="item.FeeHeadID == -2">-</span> <span v-if="item.FeeHeadID != -1">{{item.TotalAmount.toLocaleString()}}</span>  </td>
              </tr>

            </tbody>
          </table>
          <table style="width: 100%; font-size: 10px;" border="1">
            <thead>
              <tr>
                <th>Note:</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="padding-right: 17px;">
                  <ol style="padding-left: 17px; margin-top: 3px">
                    <li v-for="n in notes">{{n}}</li>
                  </ol>
                </td>
              </tr>

            </tbody>
          </table>
          <table style="width: 100%; margin-top: 50px; border-top: 1px solid black">
            <tr>
              <td style="text-align: center; font-weight: bold">Bank Officer Signature & Stamp</td>
            </tr>
          </table>
          <table style="width: 100%; margin-top: 5px;">
            <tr>
              <td style="text-align: center;"><small>{{print}}</small></td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
    <div v-else>
      <label>Loading...</label>
    </div>
  </div>

</template>

<script>
  const axios = require('axios').default;
  export default ({
    data() {
      return {
        img: '',
        st: [],
        fee: [],
        head: [],
        print: '',
        copies: ['Office Copy', 'Bank Copy', 'Student Copy'],
        banks: [],
        notes: [],
        loading: true,
      }
    },

    created: function () {
      this.loadChallanDetail();
    },

    methods: {
      loadChallanDetail() {

        var url = new URLSearchParams(window.location.search);
        var g = url.get('g');
        this.loading = true;
        var vm = this;
        axios.post('/api/PortalApi/printChallanMobileApp?g=' + g)
          .then(function (response) {
            vm.st = response.data['st'];
            vm.fee = response.data['lst'];
            vm.head = response.data['head'];
            vm.print = response.data['print'];
            vm.banks = response.data['banks'];
            vm.notes = response.data['notes'];
            vm.loading = false;
            setTimeout(printChallan, 1000);
          })
          .catch(function (error) {
            console.log(error);
          })
      },

      getStyle(ind) {
        if (ind == 0)
          return "width: 33.33%; border-right: 2px dotted black; padding-right: 15px; padding-left: 15px;";
        else if (ind == 1)
          return "width: 33.33%; padding-left: 15px; padding-right: 15px"
        else
          return "width: 33.33%; border-left: 2px dotted black; padding-left: 15px; padding-right: 15px"
      },

      //printChallan() {
      //    window.print();
      //}
    }

  })
  function printChallan() {
    window.print();
  }</script>

<style scoped>
  table {
    border-collapse: collapse;
    font-size: 12px;
    margin-top: 5px;
  }

  tr {
    border-collapse: collapse;
  }

  td {
    border-collapse: collapse;
    padding-left: 1px;
  }

  th {
    text-align: left;
    padding-left: 1px;
    background-color: lightgrey;
  }

  .btn-print {
    color: #fff;
    background-color: #28a745;
    border-color: #28a745;
    box-shadow: none;
    text-decoration: none;
    display: inline-block;
    font-weight: 400;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    border: 1px solid transparent;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1;
    border-radius: 0.25rem;
  }

  @media print {
    @page {
      size: A4 landscape;
      margin: 5px;
    }

    .btn-print {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/school/fee/StudentFeeChallan.vue